<template lang="pug">
  section
    RouterView
</template>

<script>
export default {
  name: "AdminSuperChallengeCenterWrapper"
};
</script>

<style lang="sass" scoped></style>
